import { useState } from "react";
import ProfileGeneralTab from "./ProfileGeneralTab";
import ProfileWorkTab from "./ProfileWorkTab";
import ProfileExperienceTab from "./ProfileExperienceTab";

export default function ProfileSwitchTabs({ details }) {
  const [profileTab, setProfileTab] = useState("general");

  const handleButtonSwitch = (value) => {
    setProfileTab(value);
  };

  return (
    <>
      <div className="profile-switch-tabs">
        <button
          type="button"
          onClick={(e) => handleButtonSwitch("general")}
          className={profileTab === "general" ? "active" : ""}
        >
          General
        </button>
        <button
          type="button"
          onClick={(e) => handleButtonSwitch("work")}
          className={profileTab === "work" ? "active" : ""}
        >
          Work
        </button>
        <button
          type="button"
          onClick={(e) => handleButtonSwitch("experience")}
          className={profileTab === "experience" ? "active" : ""}
        >
          Experience
        </button>
      </div>
      <div className="profile-tab-all-parent">
        {profileTab === "general" && <ProfileGeneralTab details={details} />}
        {profileTab === "work" && <ProfileWorkTab details={details} />}
        {profileTab === "experience" && (
          <ProfileExperienceTab details={details} />
        )}
      </div>
    </>
  );
}
